import React from 'react'
import Layout from '../Layout'
import { useTheme } from '../Context/ThemeContext'
import Technologies from '../Components/Technologies';
import Heading from '../Components/Heading';
import AboutImg from '../Components/AboutImg';

function About() {

    const { primaryColor, secondaryColor } = useTheme();

    return (
        <Layout>
            <div className='mx-4 grid grid-cols-1 lg:grid-cols-3 gap-3' data-aos="fade-down">
                <div className='md:col-span-2'>
                    <div className=''>
                        <Heading heading="About Me" />
                    </div>
                    <div className='mt-5'>
                        <p className={`my-2 text-sm md:text-md font-semibold ${secondaryColor} text-justify indent-8 leading-relaxed`}>
                            Hello! <span className={`${primaryColor}`}>I'm Pranesh</span> and I enjoy creating things that live on the internet. My interest in web development started back in 2018 when I decided to create an anonymous message app, and I've been hooked ever since.
                        </p>
                        <div className={`my-2 text-sm md:text-md font-semibold ${primaryColor} text-justify leading-relaxed`}>
                            Here are a few technologies I’ve been working with recently:
                            <Technologies />
                        </div>
                    </div>
                </div>
                <div className='md:col-span-1 flex flex-col items-center justify-center h-[50vh] md:h-[60vh] lg:h-[80vh]'>
                    <AboutImg />
                </div>
            </div>
        </Layout>
    )
}

export default About